import React from 'react'

export const AdFacebookPreviewContext = React.createContext()

export const AdFacebookPreviewContextProvider = ({ ad, children }) => {
  const adAccountId = ad.ad_account_id || ad.creative?.account_id

  return <AdFacebookPreviewContext.Provider value={{ adAccountId }}>{children}</AdFacebookPreviewContext.Provider>
}
